import * as React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Input, SubmitButton } from '@ixicare/ui';
import { Auth } from '@ixicare/resources';
import { t } from '~/i18n';
import { humaniseErrorToMessage } from '~utils/error';

const ForgotPasswordContainer: React.FC = () => {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState<Error | null>(null);

  const handleSubmit = React.useCallback(
    (e: React.SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      setLoading(true);
      setError(null);
      Auth.requestPasswordReset({ email })
        .then(() => setSubmitted(true))
        .catch((err) => setError(err))
        .finally(() => setLoading(false));
    },
    [email]
  );

  if (submitted) {
    return (
      <div>
        <h1 className="mb-10">{t('auth.forgotPassword.success.title')}</h1>
        <p className="mb-20">{t('auth.forgotPassword.success.description')}</p>
        <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && <Alert type="error">{humaniseErrorToMessage(error)}</Alert>}
      <Input
        label={t('auth.forgotPassword.form.email')}
        value={email}
        type="email"
        className="mb-20"
        onValueChange={setEmail}
      />
      <SubmitButton disabled={!email.length} loading={loading}>
        {t('auth.forgotPassword.form.submit')}
      </SubmitButton>
      <div className="mt-20">
        <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
      </div>
    </form>
  );
};

export default ForgotPasswordContainer;
